import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

type Props = {
    data: any[];
    id?: string;
    text: string;
    FileName: string;
};

const DataAsExcel: React.FC<Props> = ({ data, text, id, FileName }) => {
    const downloadArrayExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Processed Data');

        data.forEach((row) => {
            worksheet.addRow(row);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${FileName}.xlsx`);
    };

    const downloadObjectExcel = async () => {
        if (!Array.isArray(data) || data.length === 0 || typeof data[0] !== "object") {
            console.warn("No valid object data available for download.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Processed Data");
        const headers = Object.keys(data[0]);
        worksheet.addRow(headers);

        data.forEach((item) => {
            const row = headers.map((key) => item[key] ?? ""); 
            worksheet.addRow(row);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${FileName}.xlsx`);
    };

    return (
        <div>
            {data && id ? (
                <button type="button" className="btn btn-primary" onClick={downloadObjectExcel}>
                    {text}
                </button>
            ) : (
                <button type="button" className="btn btn-primary" onClick={downloadArrayExcel}>
                    {text}
                </button>
            )}
        </div>
    );
};

export default DataAsExcel;
